export const hotlineEmail = 'technique@bil.com';
export const hotlinePhone = '+35245904590';
export const formattedHotlinePhone = '+352 4590 4590';
